import React from "react";
import { Box, Typography, Button, Card, CardContent } from "@mui/material";
import { Add, Info } from "@mui/icons-material";

export const SectionEmptyState = ({ searchTerm, handleModal }) => (
  <Card sx={{ borderRadius: "12px", textAlign: "center", py: 4 }}>
    <CardContent>
      <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
        <Info sx={{ fontSize: 60, color: "text.secondary", opacity: 0.5 }} />
      </Box>
      <Typography variant="h6" color="textSecondary" gutterBottom>
        No se encontraron secciones
      </Typography>
      <Typography color="textSecondary" sx={{ mb: 3 }}>
        {searchTerm
          ? "Intenta con otros términos de búsqueda"
          : "No hay secciones disponibles para este documento"}
      </Typography>
      <Button
        variant="contained"
        startIcon={<Add />}
        sx={{ mt: 2, textTransform: "none" }}
        onClick={() => handleModal("add", true)}
      >
        Crear nueva sección
      </Button>
    </CardContent>
  </Card>
);
